import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "../i18n";
import {
  selectRecent,
  selectCurrent,
  changeCurrent,
  removeCustomerFromRecent,
} from "../store/customer";

/**
 * @param {object} props
 * @param {(HTMLElement) => void} props.onClick
 * @param {boolean} props.isActive
 * @returns {React.Component}
 */
export default function RecentCustomers({ onClick }) {
  const { t } = useTranslation();
  const customer = useSelector(selectCurrent);
  const recentCustomers = useSelector(selectRecent);
  const dispatch = useDispatch();

  /**
   * @type {React.MutableRefObject<HTMLDivElement|null>}
   */
  const removeCustomerRef = useRef(null);

  return (
    <div className="bg-c-gray-600 flex flex-col flex-grow rounded-lg p-2 min-h-32">
      <h1 className="text-c-gray-400 ml-3 mb-4">
        {t("admin.recentCustomers")}
      </h1>
      <div className="overflow-auto px-1">
        {recentCustomers.map((c) => (
          <div
            className={`mt-1 flex justify-between items-center hover:bg-accent-hover rounded-lg py-1 px-2 ${customer.id === c.id ? "bg-c-gray-500" : ""}`}
            key={c.id}
            onClick={(evt) => {
              if (
                removeCustomerRef.current != null &&
                removeCustomerRef.current.contains(evt.target)
              ) {
                dispatch(removeCustomerFromRecent());
              } else {
                dispatch(changeCurrent(c));
                onClick();
              }
            }}
          >
            <h2 className="cursor-pointer">
              {c.firstname} {c.lastname}
            </h2>
            <span />
            {customer.id === c.id ? (
              <svg
                ref={removeCustomerRef}
                className="h-5 w-5 xl:h-8 xl:w-8 hover:bg-c-gray-500 rounded-lg p-0.5 xl:p-2"
                fill="#ffffff"
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 490 490"
                stroke="#ffffff"
              >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <polygon points="456.851,0 245,212.564 33.149,0 0.708,32.337 212.669,245.004 0.708,457.678 33.149,490 245,277.443 456.851,490 489.292,457.678 277.331,245.004 489.292,32.337 "></polygon>
                </g>
              </svg>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
}
